import api from 'api/apiInstance';

export function clientEstateSummaryPrintApi(path: string) {
  return {
    path,
    GET: () => api.get(path),
  };
}
